export default function WhyChooseSection() {
  const reasons = [
    { title: '18+ Anos Atendendo a Indústria', desc: 'Tradição e expertise técnica acumulada em manutenção, recuperação e serviços industriais para operações críticas.', icon: 'ri-calendar-check-line' },
    { title: 'Estrutura Própria de Oficina Especializada', desc: 'Oficina equipada com tecnologia de ponta para diagnóstico, recuperação e testes de equipamentos hidráulicos e mecânicos.', icon: 'ri-building-4-line' },
    { title: 'Atendimento Multimarcas', desc: 'Atuamos com equipamentos das principais marcas nacionais e importadas, sem restrição de fabricante.', icon: 'ri-stack-line' },
    { title: 'Equipe Técnica Especializada', desc: 'Engenheiros e técnicos certificados com experiência prática em campo e oficina para entregar resultados.', icon: 'ri-user-star-line' },
    { title: 'Soluções em Campo e Oficina', desc: 'Capacidade integrada de atender tanto na planta industrial quanto na oficina, reduzindo tempo de parada.', icon: 'ri-map-pin-2-line' },
    { title: 'Foco em Disponibilidade Operacional', desc: 'Priorizamos a continuidade da operação com performance, segurança e confiabilidade dos equipamentos.', icon: 'ri-time-line' },
  ];

  const gallery = [
    {
      src: '/images/HOME/DIMENSIONAMENTO-TECNICO/MEDICAO-DIMENSIONAMENTO-HASTE-PAQUIMETRO.webp',
      alt: 'Medição de dimensionamento de haste com paquímetro digital - controle dimensional Pilar',
      title: 'Dimensionamento Técnico',
      desc: 'Medição de precisão com paquímetro digital em hastes cromadas',
    },
    {
      src: '/images/HOME/METROLOGIA-DE-PRECISAO/MEDICAO-MICROMETRO.webp',
      alt: 'Medição micrométrica com instrumento Mitutoyo - metrologia industrial Pilar',
      title: 'Metrologia de Precisão',
      desc: 'Instrumento Mitutoyo para medição micrométrica',
    },
    {
      src: '/images/HOME/CONTROLE-DE-RUGOSIDADE/MEDICAO-RUGOSIDADE-HASTE-CILINDRO.webp',
      alt: 'Medição de rugosidade em haste de cilindro hidráulico - controle de qualidade Pilar',
      title: 'Controle de Rugosidade',
      desc: 'Medição de rugosidade superficial em haste de cilindro',
    },
    {
      src: '/images/HOME/EXPOSICAO-TECNICA/EXPOSICAO-MICROMETRO.webp',
      alt: 'Exposição técnica de micrômetro industrial - instrumentos de calibração Pilar',
      title: 'Exposição Técnica',
      desc: 'Instrumentos de medição e calibração em ambiente industrial',
    },
    {
      src: '/images/HOME/CONTROLE-DE-CROMAGEM/MEDICAO-CAMADA-CROMO.webp',
      alt: 'Medição de espessura de camada de cromo em haste cilíndrica - inspeção técnica Pilar',
      title: 'Controle de Cromagem',
      desc: 'Verificação de espessura de camada de cromo em hastes',
    },
    {
      src: '/images/HOME/INSPECAO-DIMENSIONAL/MEDICAO-DIMENSAO-HASTE-MICROMETRO.webp',
      alt: 'Medição de dimensão de haste com micrômetro - inspeção dimensional Pilar',
      title: 'Inspeção Dimensional',
      desc: 'Medição de diâmetro com micrômetro em componentes hidráulicos',
    },
  ];

  return (
    <section className="relative py-24 bg-gp-graphite-light overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>
      <div className="relative z-10 px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-8 h-[2px] bg-gp-yellow"></div>
            <span className="text-gp-yellow text-sm uppercase tracking-[0.3em] font-medium">Nossa Diferença</span>
            <div className="w-8 h-[2px] bg-gp-yellow"></div>
          </div>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-white uppercase">
            Por Que <span className="text-gp-yellow">Escolher a Pilar</span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-3xl mx-auto">
            Credibilidade, estrutura e capacidade técnica construídas ao longo de mais de 18 anos atendendo a indústria brasileira.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="group bg-gp-graphite hover:bg-gp-graphite-lighter p-6 rounded-lg transition-all duration-300 hover:-translate-y-1 border border-transparent hover:border-gp-yellow/20"
            >
              <div className="w-12 h-12 bg-gp-yellow/10 rounded-sm flex items-center justify-center mb-4 group-hover:bg-gp-yellow transition-colors duration-300">
                <i className={`${reason.icon} text-gp-yellow group-hover:text-gp-graphite w-6 h-6 flex items-center justify-center transition-colors duration-300`}></i>
              </div>
              <h3 className="font-display text-base font-bold text-white uppercase mb-2 group-hover:text-gp-yellow transition-colors duration-300">
                {reason.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">{reason.desc}</p>
            </div>
          ))}
        </div>

        {/* Galeria de Precisão Técnica */}
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {gallery.map((item, index) => (
            <div key={index} className="group relative overflow-hidden rounded-lg bg-gp-graphite border border-gp-graphite-lighter h-[280px]">
              <img
                src={item.src}
                alt={item.alt}
                className="w-full h-full object-contain object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white text-sm font-semibold uppercase tracking-wider">{item.title}</p>
                <p className="text-gray-400 text-xs mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}